
import { Card } from "lib-core"


export { CardStyled, CardProps, } from "lib-core"


export { Card }

export default Card
